import { render } from "./ChatAvatar.vue?vue&type=template&id=fe42034c"
import script from "./ChatAvatar.vue?vue&type=script&lang=js"
export * from "./ChatAvatar.vue?vue&type=script&lang=js"

import "./ChatAvatar.vue?vue&type=style&index=0&id=fe42034c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/parts/ChatAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe42034c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe42034c', __exports__)) {
    api.reload('fe42034c', __exports__)
  }
  
  module.hot.accept("./ChatAvatar.vue?vue&type=template&id=fe42034c", () => {
    api.rerender('fe42034c', render)
  })

}


export default __exports__